import React, { Fragment } from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

import StepNav from './StepNav'
import StepBody from './StepBody'
import StepFooter from './StepFooter'

export default ({
  currentStep,
  history,
  options,
  toggleMap,
  totalSteps,
  trips,
  trip,
  trip: {
    acf: {
      steps
    }
  },
  wpforms,
}) => (
  <Fragment>
    <StepNav
      currentStep={currentStep}
      toggleMap={toggleMap}
      trip={trip}
    />
    {steps && steps.map((step, index) => (
      <Fragment key={trip.id + '-' + (index + 1)}>
        <TransitionGroup>
          {currentStep === (index + 1) && (
            <CSSTransition classNames="step" timeout={700}>
              <Fragment>
                <StepBody
                  step={step}
                  toggleMap={toggleMap}
                  trip={trip}
                />
                <StepFooter
                  currentStep={currentStep}
                  options={options}
                  history={history}
                  totalSteps={totalSteps}
                  trip={trip}
                  trips={trips}
                  wpforms={wpforms}
                />
              </Fragment>
            </CSSTransition>
          )}
        </TransitionGroup>
      </Fragment>
    ))}
  </Fragment>
)


// WEBPACK FOOTER //
// ./src/components/Step/Step.js